import { render, staticRenderFns } from "./AxTempGeneralReturnDialog.vue?vue&type=template&id=df6501d0&scoped=true"
import script from "./AxTempGeneralReturnDialog.vue?vue&type=script&lang=ts"
export * from "./AxTempGeneralReturnDialog.vue?vue&type=script&lang=ts"
import style0 from "./AxTempGeneralReturnDialog.vue?vue&type=style&index=0&id=df6501d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df6501d0",
  null
  
)

export default component.exports